import config from "../../config/config.json";
import { getHeaders } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const plateformSettingServices = {
  addUpdatePlateformSettings,
  getSinglePlateformSettings,
};

// Add Update Plateform Settings
async function addUpdatePlateformSettings(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addUpdatePlateformSettings`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const result = await response.json();
  const data = decryptResponse(result);
  if(data?.customMessage !== "Theme Settings has been Successfully Updated."){
    handleResponse(data)
  }
  return data;
}

// Get Single Plateform Settings Details
async function getSinglePlateformSettings(auth) {
  try {
    const signal = cancelPreviousRequest("getSinglePlateformSettings");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSinglePlateformSettings`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}